import RFFCheckbox from './RFFCheckbox';

export default RFFCheckbox;



// WEBPACK FOOTER //
// ./src/components/form/RFFCheckbox/index.jsx